import axiosInstance from 'api/axiosInstance';
import { URL_SCHEDULER_V4_PATROLS } from 'constants/urls';

/**
 * Delete a single patrol assignment via the granular V4 API.
 * Removes the patrol and all associated data (checklists, comment_list, etc.)
 * Does NOT affect any other patrols.
 *
 * @param {number} scheduleAssignmentId - The patrol's schedule_assignment_id
 * @returns {Promise<void>}
 */
const deleteSinglePatrol = async (scheduleAssignmentId) => {
  try {
    const { data } = await axiosInstance({
      method: 'DELETE',
      url: `${URL_SCHEDULER_V4_PATROLS}/${scheduleAssignmentId}`,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    });

    if (!data.success) {
      throw new Error(data.error?.message || 'Failed to delete patrol');
    }
  } catch (error) {
    console.error('[deleteSinglePatrol] Failed for ID:', scheduleAssignmentId, error);
    throw error;
  }
};

export default deleteSinglePatrol;
